import Support_Overview from '@/components/Support/Support_Overview.vue';
import { FEATURES } from '@/constants/features';

// Consolidated Service Desk workspace (items 7+8). One role-adaptive route
// family rendering Support_Overview: staff get the full tabbed workspace
// (Work | Activity | Service Desk); customers with MODULE_SERVICE_DESK get the
// bare Service Desk. `staffBypass` admits Kairon staff even without the tenant
// feature flag.
//
// Lives under src/ rather than inline in router/index.js so the redirect chain
// below is reachable from a test: router/index.js sits outside src/ and vitest
// cannot resolve its '@/' imports.
const SUPPORT_META = {
  canAccess: FEATURES.MODULE_SERVICE_DESK,
  staffBypass: true,
  requiresAuth: true,
  layout: 'default',
};

const selectedIdProps = (route) => ({ selectedId: route.params.selectedId });

export const SUPPORT_ROUTES = [
  { path: '/support', redirect: '/support/service-desk' },
  {
    path: '/support/service-desk',
    name: 'Support-ServiceDesk',
    component: Support_Overview,
    meta: { ...SUPPORT_META },
  },
  {
    path: '/support/service-desk/:selectedId',
    name: 'Support-ServiceDeskDetail',
    component: Support_Overview,
    props: selectedIdProps,
    meta: { ...SUPPORT_META },
  },
  {
    path: '/support/work',
    name: 'Support-Work',
    component: Support_Overview,
    meta: { ...SUPPORT_META },
  },
  {
    path: '/support/work/:selectedId',
    name: 'Support-WorkDetail',
    component: Support_Overview,
    props: selectedIdProps,
    meta: { ...SUPPORT_META },
  },
  // Requirements / Tickets / Timeline collapsed into /support/work. Each keeps
  // its :selectedId so existing deep links still land on the item, following
  // the /beta/support/* catch-all precedent in router/index.js.
  //
  // FLAG FOR EVAN: Cerberus's morning #eng report deep-links
  // /beta/support/tickets/<id>, which reaches this table through that catch-all
  // and now resolves via a second hop to /support/work/<id>. It keeps working,
  // but the link should be updated at source.
  { path: '/support/requirements', redirect: '/support/work' },
  { path: '/support/requirements/:selectedId', redirect: (to) => `/support/work/${to.params.selectedId}` },
  { path: '/support/tickets', redirect: '/support/work' },
  { path: '/support/tickets/:selectedId', redirect: (to) => `/support/work/${to.params.selectedId}` },
  { path: '/support/timeline', redirect: '/support/work' },
  { path: '/support/timeline/:selectedId', redirect: (to) => `/support/work/${to.params.selectedId}` },
  {
    path: '/support/activity',
    name: 'Support-Activity',
    component: Support_Overview,
    meta: { ...SUPPORT_META },
  },
  // Hades. Staff-only in effect: the tab is not rendered on the customer shell,
  // and ensureCustomerRoute() bounces any non-staff user who reaches the path
  // directly back to the Service Desk. The read API is superuser-gated anyway,
  // so a customer landing here would get an empty portfolio rather than data.
  {
    path: '/support/hades',
    name: 'Support-Hades',
    component: Support_Overview,
    meta: { ...SUPPORT_META },
  },
  {
    path: '/support/latency',
    name: 'Support-AppLatency',
    component: Support_Overview,
    meta: { ...SUPPORT_META, requiresSuperUser: true },
  },
];

export default SUPPORT_ROUTES;
